import { render } from "./PublicLayout.vue?vue&type=template&id=6014ae3a"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_08ab6b88/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__